define('frontend-common-components/objectStorageConfig/js/helpers/awsHelper',[
    './storageHelper'
], function (
    storageHelper
    ) {
    'use strict';
    //might need to update this variable if the length changes from default 100 to something else
    var AWS_ACCEPTABLE_PREFIX_LENGTH;

    var RoleARNRegex = /arn:aws:iam:[^:]{0,}:[\d]{12,12}:.{1,}/;

    return {
        isValidRoleARN: function (roleARN) {
            return RoleARNRegex.test(roleARN);
        },

        isValidAWSBucketPrefix: function (directoryPrefix) {
            return storageHelper.isValidFilePrefix(directoryPrefix);
        },

        isAWSStoragePrefixLengthAcceptable: function (directoryPrefix) {
            return storageHelper.isStoragePrefixLengthAcceptable(directoryPrefix, AWS_ACCEPTABLE_PREFIX_LENGTH);
        }
    };

});

